module.exports = __webpack_public_path__ + "front-static/media/Picture404.526b7a03ac1fa3392134601c50d3766e.jpg";